import branchService from 'ApiService/SuperAdmin/branchService';
import GenericUserList from '../../../List/GenericUserList';

const AdminList = () => {
  const columns = [
    { header: 'Admin Name', key: 'name' },
    { header: 'Email', key: 'email' },
    // { header: 'Gender', key: 'gender' },
    // { header: 'Date of Birth', key: 'dob' },
    // { header: 'Institute ID', key: 'instituteId' },
    { header: 'Branch', key: 'branchName' },
    { header: 'Location', key: 'branchLocation' },
    { header: 'Contact No', key: 'contact' },
  ];

  const fetchAdmins = async (userId, page) => {
    return await branchService.getAllBlockedAdmin(userId, page);
  };

  const updateAdmin = async (teacherData) => {
    return await branchService.updateAdmin(teacherData);
  };

  return (
    <GenericUserList
      fetchUsers={fetchAdmins}
      updateUser={updateAdmin}
      userType="Admin"
      columns={columns}
      blockedList={true}
    />
  );
};

export default AdminList;
